var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TopNewsImportant"},[_c('ul',_vm._l((_vm.item_list),function(item,i){return _c('li',{key:i},[_c('a',{attrs:{"href":`/information/` + item.id}},[_vm._v(" "+_vm._s(item.news_type_name)+_vm._s(item.display_title)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }